import { Badge, Card, CardActionArea } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import type { StudentReward } from '@monorepo/shared/src/graph/schema-generated-types-student';

type Props = {
  studentReward: StudentReward | undefined;
  handleOnClick?: (id: number) => void;
};

const Sticker: React.FC<Props> = ({ studentReward, handleOnClick }) => {
  const classes = useStyles();

  return (
    <Badge
      invisible={!studentReward?.selected}
      classes={{ badge: classes.selectedBadge }}
      badgeContent={<FontAwesomeIcon className={classes.checkIcon} icon={faCheck} />}
    >
      <Card className={classes.card} elevation={0}>
        {studentReward && (
          <CardActionArea onClick={() => handleOnClick?.(studentReward.id)}>
            <img
              src={studentReward?.reward?.asset.src}
              className={classes.image}
              alt={studentReward?.reward?.asset?.description ?? ''}
            />
          </CardActionArea>
        )}
      </Card>
    </Badge>
  );
};

const useStyles = makeStyles((theme) => ({
  card: {
    width: remCalc(264),
    height: remCalc(264),
    borderRadius: 20,
    border: `1px solid ${theme.palette.grey[400]}`,
  },
  image: {
    width: '100%',
    height: '100%',
  },
  selectedBadge: {
    width: remCalc(72),
    height: remCalc(72),
    right: '50%',
    top: '-5%',
    boxShadow: '0 0 3px 0 rgb(0 0 0 / 50%)',
    border: '4px solid #FFFFFF',
    borderRadius: '50%',
    backgroundColor: '#279451',
  },
  checkIcon: {
    color: 'white',
    fontSize: theme.typography.pxToRem(32),
  },
}));

export default Sticker;
